import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiDataService } from "src/app/api/services/api-data.service";
import { NavigationItem } from "src/app/controls/menu/models/navigation-item.interface";
import { MenuProvider } from "src/app/controls/menu/services/menu.provider";

@Injectable()
export class CompetitionService implements MenuProvider {

    /** Api data service reference */
    private service = inject(ApiDataService);

    /**
     * Obtains competitions navigation menu items
     * @returns the competitions navigation menu items
     */
    getMenuItems(): Observable<NavigationItem> {
        return this.service.get<NavigationItem>('navigation/competitions');
    }
    
}